import { useContext } from 'react';
import { StructureContext } from './structure-context';
import { hookstate, useHookstate } from '@hookstate/core';

export const globalUserState = hookstate();


export const useGroupMember = (grpname) => {
    const structureContext = useContext(StructureContext);
    const payload = useHookstate(globalUserState).get();
    if (payload && payload[`cdm-groups:${structureContext.id}`]) {
        if(Array.isArray(grpname)) {
            for(const grp of grpname) {
                if(payload[`cdm-groups:${structureContext.id}`].includes(grp)) {
                    return true;
                }
            }
            return false;
        }
        return payload[`cdm-groups:${structureContext.id}`].includes(grpname);
    }
    return false;
}

export const useGroupMembers = (grpnames) => {
    const structureContext = useContext(StructureContext);
    const user = useHookstate(globalUserState).get();
    return isGroupMembersWithoutHook(grpnames, structureContext, user);
}

export const isGroupMembersWithoutHook = (grpnames, structure, payload) => {
    if (payload && payload[`cdm-groups:${structure.id}`]) {
        for (const grpname of grpnames) {
            if (payload[`cdm-groups:${structure.id}`].includes(grpname)) {
                return true;
            }
        }
    }
    return false;
}